module.exports = __webpack_public_path__ + "static/media/linjal.c704c9a6.m4a";